import { partialInit } from "../util/partial-init";

export class AddressModel {

  constructor(data?: Partial<AddressModel>) {
    partialInit(this, data);
  }

  subBuilding: string;
  buildingName: string;
  buildingNumber: string;
  street: string;
  city: string;
  postCode: string;
  county: string;
  country: string;
}

export class SearchAddressModel {
  id: string;
  name: string;
  type: 'Container' | 'Address';
}
